import {
  SnippetElement,
  defineElement,
  onClick,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-CFQW6ARL.js";

// src/snippets/pb-shop-claims/pb-shop-claims.ts
var PbShopClaims = class extends SnippetElement {
  handleAccordionClick(elm) {
    const index = parseInt(elm.dataset.openButton);
    this.accordions[index].toggle();
    this.chevrons[index].classList.toggle("rotate-180");
  }
  connectedCallback() {
    return __async(this, null, function* () {
      var _a;
      (_a = this.openAccordions) == null ? void 0 : _a.forEach((accordion) => {
        this.handleAccordionClick(accordion);
      });
    });
  }
};
__decorateClass([
  queryAll("[data-accordion]")
], PbShopClaims.prototype, "accordions", 2);
__decorateClass([
  queryAll("[data-chevron]")
], PbShopClaims.prototype, "chevrons", 2);
__decorateClass([
  queryAll("[data-is-open]")
], PbShopClaims.prototype, "openAccordions", 2);
__decorateClass([
  onClick("[data-open-button]")
], PbShopClaims.prototype, "handleAccordionClick", 1);
PbShopClaims = __decorateClass([
  defineElement("pb-shop-claims")
], PbShopClaims);
export {
  PbShopClaims
};
